import type { JSX } from 'react';
import React from 'react';
import twMerge from 'utilities/src/twMerge';

type CardImageProps = {
  children: JSX.Element;
  classes?: string;
};

function CardImage({ children, classes = '' }: CardImageProps) {
  return <div className={twMerge('relative', classes)}>{children}</div>;
}

export default CardImage;
